import { render, staticRenderFns } from "./user-sidebar.vue?vue&type=template&id=5791d416&"
import script from "./user-sidebar.vue?vue&type=script&lang=js&"
export * from "./user-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5791d416')) {
      api.createRecord('5791d416', component.options)
    } else {
      api.reload('5791d416', component.options)
    }
    module.hot.accept("./user-sidebar.vue?vue&type=template&id=5791d416&", function () {
      api.rerender('5791d416', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/tax-payer/user-sidebar.vue"
export default component.exports